export default class Auth {
	constructor(selector = '.archon-auth__card') {
		this.card = document.querySelector(selector);

		if (!this.card) return;

		this.tabs = this.card.querySelectorAll('.archon-auth__tab');
		this.panels = this.card.querySelectorAll('.archon-auth__panel');
		this.titles = this.card.querySelectorAll('.archon-auth__title');
		this.init();
	}

	init() {
		this.bindTabs();
		this.bindPasswordToggle();

		const initialTab = this.card.dataset.initialTab || 'login';
		this.setActive(initialTab);
	}

	bindTabs() {
		this.tabs.forEach(tab => {
			tab.addEventListener('click', () => {
				this.setActive(tab.dataset.authTab);
			});
		});
	}

	setActive(name) {
		this.tabs.forEach(tab => {
			const active = tab.dataset.authTab === name;
			tab.classList.toggle('is-active', active);
			tab.setAttribute('aria-selected', active);
		});

		this.panels.forEach(panel => {
			const active = panel.dataset.authPanel === name;
			panel.classList.toggle('is-active', active);
			// panel.style.display = active ? '' : 'none';
		});

		this.titles.forEach(title => {
			title.style.display =
				title.dataset.titleFor === name ? '' : 'none';
		});
	}

	bindPasswordToggle() {
		this.card
			.querySelectorAll('.archon-auth__password-toggle')
			.forEach(btn => {
				btn.addEventListener('click', () => {
					const input = btn.previousElementSibling;

					if (!input) return;

					input.type =
						input.type === 'password' ? 'text' : 'password';
				});
			});
	}
}
document.addEventListener('DOMContentLoaded', () => {

	const tabs = document.querySelector('.archon-auth');

	if (!tabs) return;

	new Auth();
});


